import styled from '/web_modules/styled-components.js';
import { motion } from '/web_modules/framer-motion.js';
import { gap } from './Layout.js';
export const ScoreContainer = styled(motion.div).withConfig({
  displayName: "Score__ScoreContainer",
  componentId: "xfrqzw-0"
})(["padding:24px 8px 16px;overflow:hidden;@media screen and (min-width:800px){padding:0;align-self:center;}"]);
export const ScoreIncreaseArrow = styled.span.withConfig({
  displayName: "Score__ScoreIncreaseArrow",
  componentId: "xfrqzw-1"
})(["display:inline-block;width:0;height:0;border-style:solid;border-width:0 8px 13.9px 8px;border-color:transparent transparent #57dd84 transparent;"]);
export const ScoreDecreaseArrow = styled.span.withConfig({
  displayName: "Score__ScoreDecreaseArrow",
  componentId: "xfrqzw-2"
})(["display:inline-block;width:0;height:0;border-style:solid;border-width:13.9px 8px 0 8px;border-color:#c83472 transparent transparent transparent;"]);
export const ScoreNumber = styled.span.withConfig({
  displayName: "Score__ScoreNumber",
  componentId: "xfrqzw-3"
})(["font-size:14px;line-height:14px;padding:0.05px 0;:before{content:'';margin-top:--0.13181249999999994em;display:block;height:0;}:after{content:'';margin-bottom:--0.1298125em;display:block;height:0;}"]);
export const Score = styled(motion.div).withConfig({
  displayName: "Score",
  componentId: "xfrqzw-4"
})(["display:flex;", " align-items:center;"], gap('8px', 'row'));